import {
  ImageSettings,
  ImageSuiteAppInterface,
  MetaData,
  ModelImageFluxName,
  ModelImageStabilityName,
} from "../../../../Helper";
import { Box, Typography } from "@mui/material";
import { AppActionButton } from "../Shared/AppActionButton";
import { OutputImage } from "../Shared/OutputImage";
import { UploadImageModal } from "../Shared/UploadImageModal";
import { useImageSuiteGenerateBackgroundRemover } from "../../../../store/Apis/SuitesApps/ImageSuitesApi";
import SignalRService from "../../../one-query/services/SignalRService";
import "../../../SharedSuite/Suites.css";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../../../store/hooks";
import { SuiteAppSettings } from "../Shared/SuiteAppSettings";
import { appContainerStyle, appInputOutputContainerStyle } from "../Shared/styles";

export const BackgroundRemoverApp = ({
  isGenerateButtonDisabled,
  generatedImg,
  isGenerateImgLoading,
  input,
  handleInputImageChange,
  getErrorMessage,
  handleClearInput,
  handleOpenExpandImage,
  example,
  handleSetIsLoading,
  selectedModel,
  imageSettings,
  setSelectedModel,
  creditsNeeded,
}: ImageSuiteAppInterface) => {
  const {
    mutate: GenerateBackgroundRemoverRequest,
    isPending: IsBackgroundRemoverLoading,
    error,
  } = useImageSuiteGenerateBackgroundRemover();

  const [exampleMetaData, setExampleMetaData] = useState<MetaData>({});
  const appSuiteCosts = useAppSelector((s) => s.User.AppSuiteCosts);

  useEffect(() => {
    let metaData = JSON.parse(example?.metaData || "{}");
    if (metaData) {
      setExampleMetaData(metaData);
    }
  }, [example]);

  useEffect(() => {
    if (IsBackgroundRemoverLoading && handleSetIsLoading) {
      handleSetIsLoading(true);
    }
  }, [IsBackgroundRemoverLoading]);

  useEffect(() => {
    if (error) {
      getErrorMessage(error);
    }
  }, [error]);

  const handleBackgroundRemover = async (
    inputValue: File,
    selectedModel: string | undefined
  ) => {
    if (inputValue) {
      const connectionId = await SignalRService.getInstance().getConnectionId();

      const RequestData = {
        [typeof inputValue === "string" ? "imageUrl" : "image"]: inputValue,
        connectionId: connectionId,
        modelName: selectedModel,
      };
      GenerateBackgroundRemoverRequest(RequestData);
    }
  };

  const handleGenerationAction = () => {
    if (input) {
      handleBackgroundRemover(input, selectedModel);
    }
  };

  const handleSelectModel = (model: string) => {
    setSelectedModel?.(model);
  };

  return (
    <Box sx={appContainerStyle}>
      <Box className="image-suites-input-header">
            <Typography className="image-suites-input-header-title long-header-app">
            Remove image background with one touch
            </Typography>
      </Box>
      <Box sx={appInputOutputContainerStyle}>
        <Box className="image-suites-input">
          <Box className="image-suites-input-failed">
            <Typography sx={{
              fontSize: "14px",
              fontWeight: 400,
              color:"var(--Main_icons_color)",
              opacity:0.7
            }}>
              Your image 
            </Typography>
            <UploadImageModal
              inputValue={input??exampleMetaData.before}
              handleClearInput={handleClearInput}
              isGenerateImgLoading={isGenerateImgLoading}
              handleInputImageChange={handleInputImageChange}
              appTitle=""
            />
            <SuiteAppSettings
              imageSettings={undefined}
              selectedModel={selectedModel}
              handleSelectModel={handleSelectModel}
              showSetting={{ models: false, dimensions: false, seed: false }}
            />
          </Box>
          <AppActionButton
            creditsCount = {creditsNeeded?? 0}
            inputValue={input}
            appMethodFire={handleGenerationAction}
            isGenerateButtonDisabled={isGenerateButtonDisabled}
          />
        </Box>
        <Box className="image-suites-output">
          <Box className="image-suites-output-result">
            <Box
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            >
              <Typography className="image-suites-output-result-placeholder">
                {isGenerateImgLoading || generatedImg ? "Output":"Sample Output"}
              </Typography>
              <OutputImage
                slider={true}
                outputImage={true}
                imgUrl={generatedImg}
                isLoading={isGenerateImgLoading}
                handleOpenExpandImage={handleOpenExpandImage}
                sliderData={{
                  beforeImage: exampleMetaData?.before || "",
                  afterImage: exampleMetaData?.after || "",
                }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
